class SectionContactForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Add data attribute to identify this as a contact form
    this.setAttribute('data-contact-form', '');
  }

  disconnectedCallback() {
    // Clean up if needed
  }
}

customElements.define('section-contact-form', SectionContactForm);
